import "./sp-action-button-BV19roxo.js";
import { O as p } from "./observe-slot-presence-BhCYOJih.js";
import { O as u } from "./observe-slot-text-DWmBsDhw.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-more.js";
import { i as m, x as s } from "./lit-element-6iugfgmM.js";
import { S as b } from "./slottable-request-event-B1mW6PN4.js";
import { D as y, a as f } from "./Picker-D8znovwm.js";
import { o as d } from "./if-defined-D-RhGngI.js";
import { n as h } from "./property-BWlAHqg_.js";
import { t as g } from "./state-STZTbIJp.js";
import { d as v } from "./define-element-Dl91r6Vu.js";
const $ = m`
    :host{display:inline-flex}:host([quiet]){min-width:0}:host>sp-menu{display:none}::slotted([slot=icon]){flex-shrink:0}.icon{flex-shrink:0}#popover{max-width:none}:host([dir=ltr]) ::slotted([slot=icon]),:host([dir=ltr]) .icon{margin-left:calc(-1*(var(--spectrum-actionbutton-textonly-padding-left-adjusted) - var(--spectrum-actionbutton-padding-left-adjusted)))}:host([dir=rtl]) ::slotted([slot=icon]),:host([dir=rtl]) .icon{margin-right:calc(-1*(var(--spectrum-actionbutton-textonly-padding-left-adjusted) - var(--spectrum-actionbutton-padding-left-adjusted)))}:host([dir]) slot[icon-only]::slotted([slot=icon]),:host([dir]) slot[icon-only] .icon{margin-inline:calc(( var(--custom-actionbutton-edge-to-text,var(--spectrum-actionbutton-edge-to-text)) - var(--custom-actionbutton-edge-to-visual-only,var(--spectrum-actionbutton-edge-to-visual-only)))*-1)}sp-overlay:not(:defined){display:none}
`;
var x = Object.defineProperty, O = Object.getOwnPropertyDescriptor, c = (n, t, l, e) => {
  for (var a, o = e > 1 ? void 0 : e ? O(t, l) : t, r = n.length - 1; r >= 0; r--) (a = n[r]) && (o = (e ? a(t, l, o) : a(o)) || o);
  return e && o && x(t, l, o), o;
};
class i extends p(u(f, "label"), '[slot="label-only"]') {
  constructor() {
    super(...arguments), this.selects = void 0, this.listRole = "menu", this.itemRole = "menuitem", this.handleSlottableRequest = (t) => {
      this.dispatchEvent(new b(t.name, t.data));
    };
  }
  static get styles() {
    return [$];
  }
  get hasLabel() {
    return this.slotHasContent;
  }
  get labelOnly() {
    return this.slotContentIsPresent;
  }
  get buttonContent() {
    return [s`
                ${this.labelOnly ? s`` : s`
                          <slot
                              name="icon"
                              slot="icon"
                              ?icon-only=${!this.hasLabel}
                              ?hidden=${this.labelOnly}
                          >
                              <sp-icon-more
                                  class="icon"
                                  size=${this.size}
                              ></sp-icon-more>
                          </slot>
                      `}
                <slot name="label" ?hidden=${!this.hasLabel}></slot>
                <slot name="label-only"></slot>
                <slot
                    name="tooltip"
                    @slotchange=${this.handleTooltipSlotchange}
                ></slot>
            `];
  }
  render() {
    return this.tooltipEl && (this.tooltipEl.disabled = this.open), s`
            <sp-action-button
                aria-describedby=${y}
                ?quiet=${this.quiet}
                ?selected=${this.open}
                static-color=${d(this.staticColor)}
                aria-haspopup="true"
                aria-controls=${d(this.open ? "menu" : void 0)}
                aria-expanded=${this.open ? "true" : "false"}
                aria-label=${d(this.label || void 0)}
                id="button"
                class="button"
                size=${this.size}
                @blur=${this.handleButtonBlur}
                @focus=${this.handleButtonFocus}
                @keydown=${{ handleEvent: this.handleEnterKeydown, capture: !0 }}
                ?disabled=${this.disabled}
            >
                ${this.buttonContent}
            </sp-action-button>
            ${this.renderMenu} ${this.renderDescriptionSlot}
        `;
  }
  update(t) {
    t.has("invalid") && (this.invalid = !1), super.update(t);
  }
}
c([h({ type: String })], i.prototype, "selects", 2), c([h({ reflect: !0, attribute: "static-color" })], i.prototype, "staticColor", 2), c([g()], i.prototype, "labelOnly", 1), v("sp-action-menu", i);
//# sourceMappingURL=sp-action-menu-CkAMQVRo.js.map
